import { useAuthenticator } from "@aws-amplify/ui-react";
import styled from "@emotion/styled";
import { BorderAllRounded } from "@mui/icons-material";
import { Container, Box, Stack, Typography, Button } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useApplicationStore } from "../context/ApplicationStoreContext";
import { CustomerRepository } from "../DAL/repositories/CustomerRepository";
import { AppAuth } from "../util/AppAuth";

type ImageProps = {
  src: string,
  alt: string
}
export const TopPage = () => {
  const { state } = useApplicationStore();
  const { route, authStatus, user } = useAuthenticator((context) => [
    context.route,
    context.authStatus,
  ]);
  const navigate = useNavigate();

  const LinkBotton = styled(Button)({
    backgroundColor: "#d44f4c",
    BorderAllRounded: 8,
  });

  useEffect(() => {

  }, [state.customer]);


  const Image = React.memo<ImageProps>(({src, alt})=>{
    return <img src={src} alt={alt} style={{display:"block", width:"100%"}}/>
  })

  return (
    <Container sx={{ padding: 0 }}>
      <Box component="main">
        <Stack spacing={0}>
          <Image src="./images/h1.png" alt="ノベルティクッキーのご紹介。" />
          <Typography
            textAlign="center"
            py={1}
            bgcolor="#d44f4c"
            color="#fff"
            fontWeight={600}
          >
            パティシエが1つ1つ心を込めて、
            <br />
            あなただけのオリジナルクッキーを手作りします！
          </Typography>
          <Image
            src="./images/img_01.jpg"
            alt="会社やお店のロゴを入れたり、お祝いや思い出作りにご活用できます。"
          />
          <Button
            component={Link}
            to="/cookie"
            variant="contained"
            color="primary"
            sx={{
              width: "90%",
              margin: "16px auto",
              bgcolor: "#956134",
              color: "#fff",
              fontWeight: 600,
            }}
            disableElevation
          >
            注文する
          </Button>
          <Typography
            textAlign="center"
            py={1}
            bgcolor="#d44f4c"
            color="#fff"
            fontWeight={600}
          >
            ノベルティクッキーについて
          </Typography>
          <Image
            src="./images/img_03.jpg"
            alt="1枚220円、10枚からご注文承ります。"
          />
          <Typography
            textAlign="center"
            py={1}
            bgcolor="#d44f4c"
            color="#fff"
            fontWeight={600}
          >
            ご注文について
          </Typography>
          <ul>
            <li>
              <Typography>注文は10枚より3日前からお受けします。</Typography>
            </li>
            <li>
              <Typography>ご注文は3日前からお受けします。</Typography>
            </li>
            <li>
              <Typography>
                プリントするデータはお客様でご用意ください。
              </Typography>
            </li>
          </ul>
          <Button
            component={Link}
            to="/cookie"
            variant="contained"
            color="primary"
            sx={{
              width: "90%",
              margin: "16px auto",
              bgcolor: "#956134",
              color: "#fff",
              fontWeight: 600,
            }}
            disableElevation
          >
            注文する
          </Button>
        </Stack>
      </Box>
    </Container>
  );
};
